import React from 'react'
import styled from 'styled-components'
import { flex, utils, colors } from '../styles'
import { observer } from 'mobx-react'
import { store } from '../lib/utils'

import YoutubeEmbed from './YoutubeEmbed'
import EpisodePreview from './EpisodePreview'
import P from './P'
import List from "./List"
import VimeoEmbed from './VimeoEmbed'
import NavLink from './NavLink'
import H3 from './H3'

const Wrapper = styled.div`
  margin: 1rem auto;
  ${flex.vertical.alignCenter}
  ${utils.container}
  > * {
    margin-top: 1rem;
  }
`

const Outer = styled.div`
`

const Ticks = styled.div`
  margin-top: 4rem;
`

const Images = styled.div`
  width: 100%;
  ${utils.container}
`

const Image = styled.a`
  width: calc(50% - 1rem);
  padding-top: 29%;
  display: inline-block;
  margin-top: 1rem;
  &:nth-child(2n) {
    margin-left: 1rem;
  }
  background: url('${props => props.bg}') 50% 50% no-repeat;
  background-size: cover;
  border: 3px solid ${colors.blueText};
`

const UL = props => <List ticks {...props}/>
const LI = styled.li`
  pre { display: inline; }
`
const Code = styled.pre`

`

const A2 = styled.a`
  color: ${colors.blueText};
`
const A = ({ children, href = "https://gum.co/frontendcenter" }) => (
  <A2 onClick={() => window.ga && window.ga('send', 'event', 'cta', 'click', 'inline')}
      href={href} target="_blank">
    {children}
  </A2>
)

const Preview = ({ ep, vimeoId }) => {
  if (vimeoId) return <VimeoEmbed id={vimeoId}/>
  if (ep.youtube) return <YoutubeEmbed url={ep.youtube}/>
  if (ep.banner) return <EpisodePreview ep={ep}/>
  return <div/>
}

const Episode = ({ ep, vimeoId = store.vimeoIds && store.vimeoIds[ep.slug], readMore, expanded }) => (
  <Wrapper>
    <Preview ep={ep} vimeoId={vimeoId}/>
    { ep.description({ Outer, P, List, A, Code }) }
    { ep.images &&
    <Images>{
      ep.images.map((image, i) => (
        <Image key={i}
               href={image}
               target="_blank"
               bg={image}
               alt={`Preview ${i + 1} of Episode ${ep.number}`}/>
      ))}
    </Images> }
    { expanded && ep.ticks && <Ticks>
      <H3>In this episode you'll learn</H3>
      { ep.ticks({List: UL, Item: LI}) }
    </Ticks> }
    { readMore && <NavLink to={`/ep${ep.slug}`}>Read more</NavLink> }
  </Wrapper>
)

export default observer(Episode)



/** WEBPACK FOOTER **
 ** ./src/components/Episode.js
 **/